import { authFetch } from "./authProvider";

export const notifyCustomer = async (notificationData, orgId) => {
  let url = "notification-service/v2/organizations/" + orgId + "/notify";
  return await authFetch("post", url, notificationData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};
